import Text from "../../Components/Text"
import Icon from "../../Components/Icon"
import Button from "../../Components/Buttons/Button"
import { useNavigate } from "react-router-dom";
import TIcon from "../../Components/TIcon";
import SubscriptionInfo from "../../Components/SubscriptionInfo";
import SubscriptionTable from "../../Components/SubcriptionTable";
import Footer from "../../Components/Footer";
import { useModal } from "../../Components/Modal";
import AGB from "../../Components/AGB";
import DSE from "../../Components/DSE";
import Impressum from "../../Components/Impressum";
import CookieInfo from "../../Components/CookieInfo";
import { useEffect, useState, useRef } from "react";
import SmallImage from "../../Components/SmallImage";

const MainPage = () => {
    const navigate = useNavigate();
    const { openModal, ModalView, closeModal } = useModal()
    const [isCookie, setIsCookie] = useState(false)

    const featuresRef = useRef(null);
    const productsRef = useRef(null);
    const statsRef = useRef(null);
    const ordersRef = useRef(null);
    const teamRef = useRef(null);
    const pricingRef = useRef(null);
    const workspaceRef = useRef(null);
    const deviceRef = useRef(null);

    useEffect(() => {
        const accepted = localStorage.getItem("cookiesAccepted");
        if (!accepted) {
            setIsCookie(true)
            openModal(<CookieInfo onAccept={acceptCookies} />);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("cookiesAccepted", "true");
        closeModal();
        setIsCookie(false)
    };

    const scrollToSection = (ref) => {
        ref.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    const infoBox = (icon, title, content, ref) => {

        return (
            <div onClick={() => scrollToSection(ref)} className="rounded-md bg-gray-50 shadow-lg hover:shadow-lg border-2 border-gray-300 hover:border-blue-300 p-6 flex flex-col w-full">
                <div className="flex w-full gap-6 justify-center">
                    <TIcon name={icon} />
                    <Text type="title">{title}</Text>
                </div>

                <Text type="main" classNames="text-gray-600 mt-2">
                    {content}
                </Text>
            </div>
        )
    }

    const main = () => (
        <>
            <div className="flex flex-col w-full ">
                {/* Einleitung */}
                <div className="flex flex-col w-full">
                    <div className="text-center flex justify-center p-6 ">
                        <div className="flex flex-col py-6 w-full md:w-2/3 text-center">
                            <div className="flex justify-center w-full">
                                <img
                                    src="/assets/logo-new.png"
                                    alt="Logo Cashier One"
                                    className="w-1/3"
                                />
                            </div>
                            
                            <Text type="webtitle">Kassensystem für Gastro-Betriebe – starte dein Business erfolgreich</Text>
                            <Text type="main" classNames="text-gray-600 mt-2">
                                Mit <strong>Cashier One</strong> hast du deine Kasse, Bestellungen und Statistiken jederzeit im Griff – einfach, schnell und ohne komplizierte Technik.
                            </Text>
                        </div>
                    </div>
                    <div className="flex justify-center w-full">
                        <img
                            src="/assets/stockImage2.png"
                            alt="Barista bedient Kunden mit Tablet-Kasse"
                            className="
                                w-full max-w-5xl
                                [mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)]
                                [-webkit-mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)]
                                "
                        />
                    </div>
                </div>


                <div className="flex flex-col">
                    {/* Features */}
                    <div ref={featuresRef} className="border-b rounded p-6 text-center flex justify-center w-full">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Ein Business - Eine App</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Cashier One kommt mit allen Features, welche du für deinen Betrieb brauchst
                            </Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Vom Foodtruck bis zum Restaurant
                            </Text>
                            <div className="flex flex-col gap-2 w-full mt-6">
                                <div className="flex flex-col md:flex-row gap-2 w-full mt-6 justify-center">
                                    {infoBox("reserved-line", "Kassenterminal", "Intuitives Terminal für blitzschnelle Bestellungen – einfach, übersichtlich und immer zur Hand.", ordersRef)}
                                    {infoBox("receipt", "Digitaler Bestellmonitor", "Schluss mit Zetteln und Chaos. Alle Bestellungen landen direkt in der Küche – klar strukturiert und in Echtzeit.", ordersRef)}
                                    {infoBox("user", "Teamverwaltung", "Lade dein Team ein, vergib individuelle Rollen und behalte jederzeit die volle Kontrolle über Zugriffe.", teamRef)}
                                </div>
                                <div className="flex flex-col md:flex-row gap-2 w-full mt-6 justify-between">
                                    {infoBox("settings", "Komplettes Produktmanagement", "Produkte, Kategorien, Preise und Rabatte – alles zentral verwalten und jederzeit anpassen.", productsRef)}
                                    {infoBox("home", "Multi-Workspace System", "Verwalte mehrere Standorte oder Konzepte in einem Account. Wechsle nahtlos zwischen deinen Restaurants.", workspaceRef)}
                                    {infoBox("device-tablet", "Flexibel auf jedem Gerät", "Kein teures Kassensystem nötig. Cashier One läuft auf Tablets, Smartphones und PCs – einfach Browser öffnen und loslegen.", deviceRef)}
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Produkte verwalten */}
                    <div ref={productsRef} className="border-b rounded p-6  text-center bg-slate-100 flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Produkte & Preise in deiner Hand</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Lege Produkte an, ändere Preise oder Angebote im Handumdrehen. Hinterlege EAN-Codes, scanne sie in Statistiken und verwalte Produkte in Gruppen – z.B. saisonale Produkte deaktivieren oder löschen.
                            </Text>
                            <div className="flex gap-2 w-full mt-6">
                                <SmallImage src={"demo-category.png"} subtitle="Gruppen/Kategorie Managenment" />
                                <SmallImage src={"demo-product.png"} subtitle="Produkt Managenment" />
                            </div>
                        </div>
                    </div>

                    {/* Bestellungen live */}
                    <div ref={ordersRef} className="border-b rounded p-6  text-center flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Bestellungen live</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Sieh alle eingehenden Bestellungen in Echtzeit – wie bei großen Fast-Food-Ketten, direkt über deine Kasse oder das Web.
                            </Text>
                            <div className="flex gap-2 w-full mt-6">
                                <SmallImage src={"demo-register.png"} subtitle="Auf der Kasse abgeschlossen" />
                                <SmallImage src={"demo-monitor.png"} subtitle="Direkt auf den Bestellmonitor" />
                            </div>
                        </div>
                    </div>

                    {/* Verkäufe & Statistiken */}
                    <div ref={statsRef} className="border-b rounded p-6  text-center bg-slate-100 flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Verkäufe & Statistiken</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Behalte alle Verkäufe und Umsätze jederzeit im Blick – übersichtlich, detailliert und nachvollziehbar.
                            </Text>
                            <div className="flex gap-2 w-full mt-6">
                                <SmallImage src={"demo-stats.png"} subtitle="Analysiere Verkäufe und Waste" />
                                <SmallImage src={"demo-pie.png"} subtitle="Erstelle MWST Berichte ganz einfach" />
                            </div>
                        </div>
                    </div>

                    {/* Mitarbeiterverwaltung */}
                    <div ref={teamRef} className="border-b rounded p-6  text-center flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Teamverwaltung</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Lade Mitarbeiter kostenlos in deinen Workspace ein. Rollen können zwischen Manager und Mitarbeiter gewechselt werden – Mitarbeiter haben keinen Zugriff auf Statistiken oder Einstellungen.
                            </Text>
                            <div className="flex gap-2 w-full mt-6">
                                <SmallImage src={"demo-worker.png"} subtitle="Lade registrierte Benutzer mit deren Email ein" />
                                <SmallImage src={"demo-role.png"} subtitle="Verwalte deren Rollen für Workspace-Berechtigungen" />
                                <SmallImage src={"demo-access.png"} subtitle="Schränke Funktionen für Benutzer ein" />
                            </div>
                        </div>
                    </div>

                    {/* Workspaces */}
                    <div ref={workspaceRef} className="border-b rounded p-6  text-center bg-slate-100 flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Mehrere Workspaces</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Arbeite an mehreren Standorten oder Restaurants gleichzeitig. Wechsle einfach den Workspace über das Dropdown oben. Du kannst auch zu anderen Workspaces eingeladen werden.
                            </Text>
                            <div className="flex gap-2 w-full mt-6">
                                <SmallImage src={"demo-workspace.png"} subtitle="Erstelle einfach einen neuen Workspace oder lass dich zu weiteren einladen" />
                                <SmallImage src={"demo-dropdown.png"} subtitle="Wechsle dein Workspace über das Dropdown" />
                            </div>
                        </div>
                    </div>

                    {/* Android App */}
                    <div className="border-b rounded p-6 text-center flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Android App mit erweiterten Funktionen</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Noch mehr Kontrolle: Die Android App unterstützt SumUp-Kartenzahlungen (Business Plan), ermöglicht eingeschränkte offline Nutzung bei vorherigem Online-Login und synchronisiert automatisch alle Daten.
                            </Text>
                            <Text type="main" classNames="text-blue-600">
                                Demnächst erhältlich
                            </Text>
                        </div>
                    </div>

                    <div ref={pricingRef} className="flex justify-center text-center p-6  bg-slate-100 rounded gap-4">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Preise & Pläne</Text>
                            <Text type="main" classNames="text-gray-600">
                                Wähle den Plan, der zu deinem Business passt – ohne versteckte Kosten.
                            </Text>
                            <Text type="main" classNames="text-gray-600">
                                Du zahlst <strong>pro Workspace</strong>, nicht pro Gerät – nutze die Kasse auf mehreren Tablets, Handys oder anderen internetfähigen Geräten ohne Aufpreis.
                            </Text>

                            <SubscriptionInfo subscribable={false} />
                            <SubscriptionTable />
                        </div>
                    </div>

                    <div className="border-b rounded p-6 text-center flex justify-center bg-blue-200">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitletwo">Bereit für dein erfolgreiches Gastro-Business?</Text>
                            <Text type="main" classNames="text-gray-600 mt-2">
                                Starte jetzt mit <strong>Cashier One</strong> und behalte Kasse, Bestellungen und dein Team immer im Griff – einfach, schnell und stressfrei.
                            </Text>
                            <Button classNames="w-full shadow-lg mt-4" buttonColor={"bg-[#3B82F6] hover:bg-[#1E40AF]"} children={
                                <div className="flex flex-row justify-between items-center p-1 h-full w-full">
                                    <Text type="orderitem" classNames="w-full text-center text-white">Zur App</Text>
                                    <TIcon name="arrow-right" color="white" />
                                </div>
                            } onClickAction={() => navigate("/app")} />
                        </div>
                    </div>

                    {footerContent()}
                </div>
            </div>
        </>
    )

    const footerContent = () => (
        <div className="flex flex-col text-center p-6 bg-gray-500 gap-4 w-full">
            <div className="flex justify-center items-center gap-6 w-full">
                {footerItemWrapper("Impressum", <Impressum />)}
                {footerItemWrapper("Datenschutzerklärung", <DSE />)}
                {footerItemWrapper("AGB", <AGB />)}
                <a
                    href="mailto:raycraftstudios.ch@gmail.com?subject=Cashier%20One%20Support"
                    className="text-white hover:underline"
                >
                    <Text classNames={"text-white hover:underline"}>Kontakt</Text>
                </a>
            </div>
            <div className="w-full flex justify-center">
                <Icon iconName={"logo1rcs.png"} classNames="w-20 rounded-md" />
            </div>
            
            <Footer textColor="text-white" />
        </div>
    )

    const footerItemWrapper = (title, modalContent) => {
        return (<div onClick={() => { setIsCookie(false); openModal(modalContent) }}>
            <Text classNames={"text-white hover:underline"}>{title}</Text>
        </div>)
    }

    const refButton = (text, ref) => {
        return (
            <Button onClickAction={() => scrollToSection(ref)} buttonColor="transparent" borderStyle="">
                <Text type="buttontext" classNames={"hover:underline"}>{text}</Text>
            </Button>
        )
    }

    return (
        <div className="flex flex-col h-full w-full bg-white">
            {/* Navbar */}
            <div className="flex items-center justify-between p-3 border-b border-gray-200">
                <div className="flex items-center w-full gap-4">
                    <Icon iconName={"logo-new.png"} classNames="w-20" />
                    <Text type={"webtitletwo"}>Cashier One</Text>
                </div>
                <div className="flex w-full justify-end gap-4">
                    <div className="hidden md:flex items-center gap-4">
                        {refButton("Funktionen", featuresRef)}
                        {refButton("Kassenterminal", ordersRef)}
                        {refButton("Statistiken", statsRef)}
                        {refButton("Preise", pricingRef)}
                    </div>

                    <Button classNames="w-fit shadow-lg" buttonColor={"bg-[#3B82F6] hover:bg-[#1E40AF]"} children={
                        <div className="flex flex-row justify-between items-center p-1 h-full w-full">
                            <Text type="orderitem" classNames="w-full text-center text-white">Zur App</Text>
                            <TIcon name="arrow-right" color="white" />
                        </div>

                    } onClickAction={() => navigate("/app")} />
                </div>
            </div>

            {/* Content */}
            <div className="flex-1 h-full overflow-auto">
                <div className="w-full h-full flex flex-row">
                    {main()}
                </div>
                <ModalView classNames={isCookie ? "w-min h-min" : "w-min h-full"} />
            </div>
        </div>)
}
export default MainPage